(() => {
  const dialog = document.getElementById('zenx-email-draw-dialog');
  if (!dialog || !dialog.showModal) return;
  const preview = new URLSearchParams(location.search).get('zenx_welcome_preview') === '1';
  const key = 'zenx-welcome-offer-seen';
  const isEditor = Boolean(window.Shopify && window.Shopify.designMode);
  let remembered = false;
  let previousFocus = null;
  try { remembered = sessionStorage.getItem(key) === '1'; } catch {}
  const open = () => {
    const anotherDialog = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')]
      .some(element => {
        const rect = element.getBoundingClientRect();
        return element !== dialog && rect.width > 100 && rect.height > 100;
      });
    if (dialog.open || anotherDialog) return false;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.setAttribute('data-zen-signup-open', '');
    try { sessionStorage.setItem(key, '1'); } catch {}
    dialog.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    return true;
  };
  const close = () => dialog.close();
  dialog.querySelector('.zenx-draw__close')?.addEventListener('click', close);
  dialog.addEventListener('click', event => {
    if (event.target === dialog) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.removeAttribute('data-zen-signup-open');
    previousFocus?.focus?.({ preventScroll: true });
  });
  if (preview || dialog.querySelector('.zenx-draw__success')) {
    window.setTimeout(open, 150);
  } else if (!remembered && !isEditor) {
    const attempt = () => {
      if (!document.hidden && !document.querySelector('cart-drawer[open], details.menu-opening') && open()) return;
      window.setTimeout(attempt, 5000);
    };
    window.setTimeout(attempt, 10000);
  }
})();
